/**
 * Altar del Perfume — country group on the brand index.
 *
 * Each country shows a preview of its houses and opens to the full set when the header is
 * pressed. How many fit in the preview is a question of width, not of behaviour, so the count
 * lives entirely in CSS (four on a phone, six from 750px up) and this file never measures the
 * viewport.
 *
 * Progressive enhancement: the truncation only applies once `data-collapsible` is set here, so
 * with scripting off every house is visible and reachable rather than sealed behind a dead
 * button.
 */
class AltarCountry extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-altar-country-toggle]');
    if (!this.toggle) return;

    this.setAttribute('data-collapsible', '');
    this.toggle.setAttribute('aria-expanded', 'false');

    this.onClick = () => {
      const open = this.hasAttribute('data-open');
      this.toggleAttribute('data-open', !open);
      this.toggle.setAttribute('aria-expanded', String(!open));
    };

    this.toggle.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onClick);
  }
}

if (!customElements.get('altar-country')) {
  customElements.define('altar-country', AltarCountry);
}
